/**
 * * @module pages/memberships.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

const InPageLinks = Backbone.View.extend({
  el: $(document),
  
  events: {
    "click .inpage-link-item": "navigateToLink"
  },
  
  $template: undefined,

  initialize: function ($template) {
    this.render();
    this.$template = $template;
  },

  navigateToLink: function (e) {
    e.preventDefault();
    const _this = this;
    const whereToGo = $(e.target).attr("href").replace("#", "");

    _this.scrollToAnchor(whereToGo);
  },

  scrollToAnchor: function (aid) {
    const aTag = $(".block-title[id='" + aid + "']");
    let jumpLinksHeight = 0;

    if ($(window).width() > 769) {
      jumpLinksHeight = 100;
    } else {
      jumpLinksHeight = 300;
    }
    $("html,body").animate({ scrollTop: (aTag.offset().top - jumpLinksHeight) }, "slow");
  },

  createInPageLinks: function () {
    var _this = this;
    const $headings = $(".block-title", _this.$template);

    if ($headings.length == 0) {
      $(".inpage-links__content").remove();
      // return;
    } else {
      $headings.each(function () {
        const text = $(this).html();
        const href = $(this).attr("id");

        $(".inpage-link-list").append(
          '<li class="inpage-link-item"><a class="middle" href="#' +
          href +
          '">' +
          text +
          "</a></li>"
        );
      });
    }

    $(".accordion-item-details", _this.$template).on("show.bs.collapse", function (e) {
      $(e.target).prev("button").addClass("open");
    });

    $(".accordion-item-details", _this.$template).on("hide.bs.collapse", function (e) {
      $(e.target).prev("button").removeClass("open");
    });

    $(".inpage-link-list").on("show.bs.collapse", function (e) {
      $(e.target).prev(".jump-to").addClass("open");
    });

    $(".inpage-link-list").on("hide.bs.collapse", function (e) {
      $(e.target).prev(".jump-to").removeClass("open");
    });

    // if( $("body").hasClass("event-template-default") && $(window).width() < 1024){
    //   $(".article-body").prepend($(".inpage-links"));
    // }

    _this.checkScroll();
  },


  checkScroll: function () {
    const $inPageLinks = $(".inpage-links");

    $(window).on("scroll", function () {
        if (0 > $inPageLinks[1].getBoundingClientRect().y  + $inPageLinks[1].getBoundingClientRect().height) {
          $inPageLinks.addClass("scrolled");
        } else {
          $inPageLinks.removeClass("scrolled");
        }
    });
  },

  render: function () {
    this.createInPageLinks();
  },
});

export default InPageLinks;
